import { render, staticRenderFns } from "./tech-project-list.vue?vue&type=template&id=404bfce4&scoped=true"
import script from "./tech-project-list.vue?vue&type=script&lang=js"
export * from "./tech-project-list.vue?vue&type=script&lang=js"
import style0 from "./tech-project-list.vue?vue&type=style&index=0&id=404bfce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404bfce4",
  null
  
)

export default component.exports